// extracted by mini-css-extract-plugin
export var root = "Categories-root-5PlLJ";
export var rootCol = "Categories-root_col-AYV5K";
export var rootDescription = "Categories-root_description-lddE4";
export var rootHeading = "Categories-root_heading-mO4mk";
export var rootIcon = "Categories-root_icon-oMRIZ";
export var rootIconWrapper = "Categories-root_iconWrapper-JFPIU";
export var rootItem = "Categories-root_item-9RIra";
export var rootItemArticles = "Categories-root_itemArticles-rLEMf";
export var rootItemHead = "Categories-root_itemHead-3+54F";
export var rootItemIcon = "Categories-root_itemIcon-1+XbS";
export var rootItemTextContent = "Categories-root_itemTextContent-McJed";
export var rootItemTitle = "Categories-root_itemTitle-Xb0xq";
export var rootRow = "Categories-root_row-J9Xvy";
export var rootWrapper = "Categories-root_wrapper-zO+dm";